import path from "path";

import glob from "glob";
import { VFC } from "react";

import { getIntegrations, Integration } from "api/get-integrations";
import { WorkInProgress } from "components/work-in-progress";
import { PageProps } from "pages/_app";

const slugOverrides =  ["webhook-v2", "hightouch-personalization-api"];
const formatDestinationSlug = (slug: string) => slug.toLowerCase().replace("-destination", "");

export async function getStaticPaths() {
    const { destinations } = await getIntegrations();

    const destinationSlugs = destinations
      .filter((data) => (data.status === "released" || data.status === "alpha" || data.status === "deprecated"))
      .filter((data) => data.approvalRequirement !== "to_view")
      .map((data) => formatDestinationSlug(data.slug));

    const docsPages = await glob.sync("**/*.mdx", null);

    const documentedDestinations = docsPages
      .filter(page => page.includes("destinations"))
      .map(page => path.parse(page).name.toLowerCase());

    const undocumentedDestinations = destinationSlugs
      .filter(slug => !documentedDestinations.includes(slug))
      .filter(slug => !slugOverrides.includes(slug));

    const paths = undocumentedDestinations
      .map((slug) => {
        return { params: { slug } }
      });
    
    return {
      paths,
      fallback: false
    };
  };

export async function getStaticProps({ params }) {
    const { destinations, sources } = await getIntegrations();
    const { slug } = params;

    const destination = destinations
    .find((data) => formatDestinationSlug(data.slug) === slug);

    if (!destination) {
      return {
        notFound: true,
      }
    }

    const title = destination.name;
    const description = destination.shortPitch || destination.vendorAbout;

    return {
      props: {
        meta: {
          title,
          description,
          slug
        },
        sources,
        destinations,
        destination
      },
      revalidate: 60,
    };
  }

const conditionalWIP: VFC<Readonly<PageProps & { destination: Integration}>> = ({
    meta, destination
  }) => {
    const {title, description } = meta;
    const { icon, status, type, deprecatedAt, sunsetAt } = destination

    return (
      <WorkInProgress
        icon={icon}
        status={status}
        type={type}
        title={title}
        description={description}
        deprecatedAt={deprecatedAt}
        sunsetAt={sunsetAt}
      />
    );
};

export default conditionalWIP;